/* eslint-disable */
export default {
  topic: 'Título da reunião',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
